"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notificationZHTW = exports.notificationZH = exports.notificationVI = exports.notificationTH = exports.notificationKO = exports.notificationJA = exports.notificationEN = exports.Notification = void 0;

require("object-assign-polyfill");

var preact_1 = require("preact");

require("promise-polyfill/src/polyfill");

require("whatwg-fetch");

var Notification_1 = __importDefault(require("./components/Notification"));

exports.Notification = Notification_1.default;

var en_1 = __importDefault(require("./locales/en"));

exports.notificationEN = en_1.default;

var ja_1 = __importDefault(require("./locales/ja"));

exports.notificationJA = ja_1.default;

var ko_1 = __importDefault(require("./locales/ko"));

exports.notificationKO = ko_1.default;

var th_1 = __importDefault(require("./locales/th"));

exports.notificationTH = th_1.default;

var vi_1 = __importDefault(require("./locales/vi"));

exports.notificationVI = vi_1.default;

var zh_1 = __importDefault(require("./locales/zh"));

exports.notificationZH = zh_1.default;

var zh_TW_1 = __importDefault(require("./locales/zh-TW"));

exports.notificationZHTW = zh_TW_1.default;

var renderNotification = function renderNotification(rootDom) {
  if (rootDom == null) {
    // Handle fatal errors in your app.
    throw new Error("Could not find root element");
  }

  (0, preact_1.render)((0, preact_1.h)(Notification_1.default, null), rootDom);
};

exports.default = renderNotification;